const ANALYSIS_KEY = "brainbet_analysis";
const LIMIT = 5;
const LIMIT_REGISTERED = 3;

export function getAnalysisState() {
    const stored = localStorage.getItem(ANALYSIS_KEY);
    if (!stored) return { count: 0, date: new Date().toDateString() };
    return JSON.parse(stored);
}

export function canAnalyzeMore(loggedIn) {
    const state = getAnalysisState();
    const today = new Date().toDateString();
    if (state.date !== today) {
        localStorage.setItem(ANALYSIS_KEY, JSON.stringify({ count: 0, date: today }));
        return true;
    }

    let calculatedLimit = LIMIT;
    if (loggedIn) {
        calculatedLimit = LIMIT + LIMIT_REGISTERED
    }
    return state.count < calculatedLimit;
}

export function incrementAnalysisCount() {
    const state = getAnalysisState();
    const today = new Date().toDateString();
    const newCount = state.date === today ? state.count + 1 : 1;
    localStorage.setItem(ANALYSIS_KEY, JSON.stringify({ count: newCount, date: today }));
}